export default __webpack_public_path__ + "static/media/portfolio-105.f575340c.jpg";